import { render, staticRenderFns } from "./CakeCityList.vue?vue&type=template&id=806dfcc2&scoped=true"
import script from "./CakeCityList.vue?vue&type=script&lang=js"
export * from "./CakeCityList.vue?vue&type=script&lang=js"
import style0 from "./CakeCityList.vue?vue&type=style&index=0&id=806dfcc2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "806dfcc2",
  null
  
)

export default component.exports